import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { documents } from './document';

declare var jQuery;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  docs = [];
  docsVisible;
  arrayUserDocs = [];
  lvlNames = [
      {
          id: 1,
          title: 'Выберите раздел',
          nominative: 'раздел',
          genitive: 'раздела'
      },
      {
          id: 2,
          title: 'Выберите отрасль',
          nominative: 'отрасль',
          genitive: 'отрасли'
      },
      {
          id: 3,
          title: 'Ваш товар',
          nominative: 'товар',
          genitive: 'товара'
      },
      {
          id: 4,
          title: 'Документы для',
          nominative: 'документ',
          genitive: 'документа'
      },
      {
          id: 5,
          title: 'Документы для оформления',
          nominative: 'документ для оформления',
          genitive: 'документов для оформления'
      },
  ];
  lvlCurrent = 1;
  lvlFinish = 5;
  activeLvlClass = 'active-step';
  empty = '';
  currentStepClass = 'current-step';
  classNameLvl = 'steps';

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.docs = documents;
    this.docsVisible = this.getDocs(1, 0);
  }

  /**
   *   Get docs by lvl and parent id
   */
  getDocs(lvl: number, patent: any): any {
      const response = [];
      this.docs.forEach((value) => {
          if (typeof patent === 'object' && typeof value.parent === 'object') {
              if (value.lvl === lvl && JSON.stringify(patent) === JSON.stringify(value.parent)) {
                  response.push(value);
              }
          } else if (typeof value.parent === 'object') {
              if (value.lvl === lvl && value.parent.includes(patent)) {
                  response.push(value);
              }
          } else if (typeof value.parent === 'number') {
              if (value.lvl === lvl && value.parent === patent) {
                  response.push(value);
              }
          }
      });
      return response;
  }

  /**
   *  Action click doc. If current lvl = lvl finish - return
   *  Set new info in arrayUserDocs, currentLvl
   */
  onClinkDoc(id: number) {
      const elemToScroll = document.getElementsByClassName(this.classNameLvl);

      if (elemToScroll[0]) {
          elemToScroll[0].scrollIntoView({block: 'center', behavior: 'smooth'});
      }

      const currentDoc = this.getDocById(id);

      if (currentDoc.lvl === this.lvlFinish) {
          return;
      }

      this.arrayUserDocs[currentDoc.lvl - 1] = {
          name: currentDoc.name,
          id: currentDoc.id
      };
      this.deleteUserDocs(currentDoc.lvl);
      this.setCurrentLvl(currentDoc.lvl + 1);
      this.docsVisible = this.getDocs(currentDoc.lvl + 1, currentDoc.id);
  }

  getDocById(id: number): any {
      const docFilter = this.docs.filter(x => x.id === id);
      if (!docFilter[0]) {
          return;
      }
      return docFilter[0];
  }

  deleteUserDocs(from: number) {
      this.arrayUserDocs.splice(from, this.arrayUserDocs.length - from);
  }

  /**
   *  Action click lvl. If user go to next lvl without choice past - return
   */
  onClinkLvl(lvl: number) {
      if (!this.arrayUserDocs[lvl - 1]) {
          return;
      }
      this.setCurrentLvl(lvl);
      const lastSelectedDoc = this.getDocById(this.arrayUserDocs[lvl - 1].id);
      this.deleteUserDocs(lvl - 1);
      this.docsVisible = this.getDocs(lastSelectedDoc.lvl, lastSelectedDoc.parent);
  }

  setCurrentLvl(lvl: number): void {
      this.lvlCurrent = lvl;
  }

  /**
   *  Action get text of lvl for Tile and ul
   */
  getTextOfLvl(isNameTile?: boolean): string {
      const text = {
              nameUl: '',
              nameTile: '',
          };

      const obLvl = this.lvlNames.filter(value => value.id === this.lvlCurrent);
      const obLvlNext = this.lvlNames.filter(value => value.id === this.lvlCurrent + 1);

      if (!obLvl[0]) {
          return;
      }
      text.nameTile = `Выберите ${obLvl[0].nominative}`;


      text.nameUl = this.lvlCurrent === this.lvlFinish ?
                'Перечень документов для оформления'   :
                `Выберите ${obLvl[0].nominative}`;

      if (obLvlNext[0]) {
          text.nameTile += `, чтобы перейти к Выбору ${obLvlNext[0].genitive}`;
      }
      if (isNameTile) {
          return text.nameTile;
      }
      return text.nameUl;
  }

  isBtnShow(): boolean {
      return this.lvlCurrent === this.lvlFinish;
  }

  /**
   *  Action parse user choice docs to string.
   *  Parse array user docs and array docs, that visible on last lvl
   */
  arrayUserDocsToString() {
      const responce = [];
      const lastUserDoc = this.arrayUserDocs[this.arrayUserDocs.length - 1];
      const lastChoice = this.getDocById(lastUserDoc.id);
      const userDocs = this.getDocs(lastChoice.lvl + 1, lastChoice.id);

      responce.push('<br><ul class="array-user-docs"><li><b>Пользователь выбрал:</b></li>');
      this.arrayUserDocs.forEach((value) => {
          responce.push('<li>' + value.name + '</li>');
      });
      responce.push('</ul>');

      responce.push('|<br><ul class="user-docs"><li><b>' + this.getTextOfLvl(false) + '</b>:</li>');
      userDocs.forEach((value) => {
          responce.push('<li>' + value.name + '</li>');
      });
      responce.push('</ul><br>|');

      return responce;
  }

  openModal(event, doc) {
    jQuery('#selector').slideDown();
    jQuery('#selector .document_name').text(doc);
    jQuery('#selector input[name=document]').val(doc);
  }
}
